import React, { Fragment } from 'react'
import styles from './SelectionMenu.scss'
import { PopoverLinkMenu } from 'common/styleguide/PopoverLinkMenu'
import { Icon } from 'common/Icon'

export class SelectionMenu extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      expanded: false
    }
  }

  setRef = (ref) => {
    this._menu = ref
  }

  toggleMenu = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  render () {
    const { disabled, children, title, intl } = this.props
    const { expanded } = this.state

    return (
      <Fragment>
        <span ref={this.setRef} onClick={this.toggleMenu} className={styles.menuButton}>{title} {expanded ? <Icon i='ios-arrow-up' /> : <Icon i='ios-arrow-down' />}</span>
        {expanded && <PopoverLinkMenu
          container={window.body}
          intl={intl}
          target={() => this._menu}
          insideMargin={false}
          placement='bottom'
          noArrow
          slim
          disabled={disabled}
          onRequestClose={this.toggleMenu}>
          {children}
        </PopoverLinkMenu>}
      </Fragment>
    )
  }
}
